export default __webpack_public_path__ + "984f077ef52a2ee2514ca3cbf216a22f.png";